import React from 'react';
import { useTranslation } from 'react-i18next';
import { DistanceUnitFormatter } from 'components/modules/master/formatters';
import { DEFAULT_DISTANCE_UNIT } from 'utils/localization/types';
import { useDistance } from 'hooks/useDistance';
import { DISTANCE_METHODS } from 'components/modules/shipper/RoutingConfiguration';
import DescriptionListItem from 'components/v2/DescriptionListItem';
export const OrderDistance = ({ distance, routeConfiguration, fromUnit = 'm', toUnit = DEFAULT_DISTANCE_UNIT, }) => {
    var _a;
    const { t } = useTranslation();
    const { hasDistance, isPcMiler, routerName } = useDistance({
        distance,
        routeConfiguration,
    });
    if (!hasDistance) {
        return null;
    }
    const version = routeConfiguration === null || routeConfiguration === void 0 ? void 0 : routeConfiguration.routing_configuration;
    const versionLabel = isPcMiler
        ? version === 'Current'
            ? t('CURRENT')
            : version.replace(/^\D+/g, '')
        : null;
    const distanceMethod = routeConfiguration === null || routeConfiguration === void 0 ? void 0 : routeConfiguration.distance_method;
    const distanceMethodLabel = (_a = Object.values(DISTANCE_METHODS).find((option) => option.value === distanceMethod)) === null || _a === void 0 ? void 0 : _a.name;
    return (React.createElement(DescriptionListItem, { dataTestId: "order-distance", label: t('TOTAL_DISTANCE'), className: "mt-2" },
        React.createElement("div", null,
            React.createElement(DistanceUnitFormatter, { fromUnit: fromUnit, toUnit: toUnit, distance: distance }),
            ' ',
            "(",
            t('ROUTING'),
            ": ",
            routerName,
            isPcMiler && (React.createElement(React.Fragment, null,
                ", ",
                t('VERSION'),
                ": ",
                versionLabel)),
            ")"),
        distanceMethodLabel && (React.createElement("div", { "data-testid": "order-distance-method" },
            "Distance Method: ",
            distanceMethodLabel))));
};
